import { render, staticRenderFns } from "./rejeitados.vue?vue&type=template&id=6219280a&"
import script from "./rejeitados.vue?vue&type=script&lang=js&"
export * from "./rejeitados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports